exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".console-wrap[data-v-65c7cf14] .el-container{margin-bottom:140px!important}.approval[data-v-65c7cf14]{padding:20px;position:relative;background:#fff}.title[data-v-65c7cf14]{margin:30px 0}.title h1[data-v-65c7cf14]{font-size:16px;font-family:\\\\5FAE\\8F6F\\96C5\\9ED1}.custom-inline[data-v-65c7cf14]{margin-bottom:10px}.custom-inline[data-v-65c7cf14] .el-tag{margin-top:10px;margin-right:10px}.footer[data-v-65c7cf14]{border-top:1px solid #ccc;padding:15px}.custom-a[data-v-65c7cf14]{color:#5597ec;text-decoration:underline}.custom-a[data-v-65c7cf14]:hover{color:red}.custom-table-style[data-v-65c7cf14] .el-table__body tr.current-row>td{color:#ec1c1c}.content[data-v-65c7cf14] .el-form-item{margin-bottom:40px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"importLoaders":0,"alias":{"/assets":"/opt/nodeapps/svndata/jzq-web/assets","/static":"/opt/nodeapps/svndata/jzq-web/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-65c7cf14","scoped":true,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./pages/console/Approval.vue
// module id = S1QD
// module chunks = 102